<div class="invoice-details-view-container" *ngIf="invoiceObject" fxLayout="column" fxLayoutGap="15px"
     [formGroup]="invoiceForm">
  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + invoiceObject?.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="invoiceObject?.status?.name">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="processingRequest || !enableSaveButton"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane faktury</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Miesiąc rozliczeniowy" [value]="invoiceObject?.billingMonth"></app-detail>

              <mat-form-field fxFlex="50">
                <mat-label>Numer</mat-label>
                <input matInput placeholder="Numer" [formControl]="numberControl" [required]="true">
                <mat-error *ngIf="numberControl.hasError('required')">To pole jest wymagane</mat-error>
                <mat-error *ngIf="numberControl.hasError('backendError')">{{ numberControl.getError('backendError') }}
                </mat-error>

              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <ng-container *ngIf="invoiceObject?.mandateBill">
                <mat-form-field fxFlex="50">
                  <mat-label>Kwota faktury</mat-label>
                  <input type="number" matInput placeholder="Kwota faktury" [formControl]="grossControl">
                  <mat-error *ngIf="grossControl.hasError('required')">To pole jest wymagane</mat-error>
                  <mat-error *ngIf="grossControl.hasError('backendError')">
                    {{ grossControl.getError('backendError') }}
                  </mat-error>
                </mat-form-field>

                <app-detail fxFlex="50" header="Kwota do wypłaty">
                  {{ calculatePayoutAmount() | number:'1.2-2' }} zł
                </app-detail>
              </ng-container>

              <ng-container *ngIf="!invoiceObject?.mandateBill && invoiceObject.partner">
                <mat-form-field fxFlex="50">
                  <mat-label>Kwota faktury</mat-label>
                  <input type="number" matInput placeholder="Kwota" [formControl]="netControl">
                  <mat-error *ngIf="netControl.hasError('required')">To pole jest wymagane</mat-error>
                  <mat-error *ngIf="netControl.hasError('backendError')">
                    {{ netControl.getError('backendError') }}
                  </mat-error>
                </mat-form-field>

                <app-detail fxFlex="50" header="Kwota do wypłaty">
                  {{ calculatePayoutAmount() | number:'1.2-2' }} zł
                </app-detail>
              </ng-container>

              <ng-container *ngIf="!invoiceObject?.mandateBill && !invoiceObject.partner">
                <mat-form-field fxFlex="50">
                  <mat-label>Kwota faktury (brutto)</mat-label>
                  <input type="number" matInput placeholder="Kwota" [formControl]="grossControl">
                  <mat-error *ngIf="grossControl.hasError('required')">To pole jest wymagane</mat-error>
                  <mat-error *ngIf="grossControl.hasError('backendError')">
                    {{ grossControl.getError('backendError') }}
                  </mat-error>
                </mat-form-field>

                <app-detail fxFlex="50" header="Kwota do wypłaty">
                  {{ calculatePayoutAmount() | number:'1.2-2' }} zł
                </app-detail>
              </ng-container>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" style="margin-top: 20px">
              <div fxFlex="50">
                <app-datepicker
                  label="Data wystawienia"
                  placeholder="2000-01-01"
                  [required]="true"
                  [control]="createdAtControl"
                ></app-datepicker>
              </div>

              <div fxFlex="50">
              </div>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Samofakturowanie"
                               [value]="invoiceObject.selfBilling"></app-detail-bool>
            </div>

            <div fxLayout="row" *ngIf="invoiceObject.suspendedNote">
              <app-detail fxFlex="100" header="Powód wstrzymania" [value]="invoiceObject.suspendedNote"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="invoiceObject.rejectedNote">
              <app-detail fxFlex="100" header="Powód odrzucenia" [value]="invoiceObject.rejectedNote"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="invoiceObject.toBeCorrectedNote">
              <app-detail fxFlex="100" header="Dane do korekty" [value]="invoiceObject.toBeCorrectedNote"></app-detail>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Uwagi</mat-label>
                <input appCapitalizeFirst matInput placeholder="Uwagi" [formControl]="noteControl" [required]="false">
              </mat-form-field>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane sprzedawcy</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <mat-form-field fxFlex="50">
                <mat-label>Nazwa firmy</mat-label>
                <input appCapitalizeFirst matInput placeholder="Nazwa firmy" [formControl]="sellerCompanyNameControl"
                       [required]="true">
                <mat-error *ngIf="sellerCompanyNameControl.hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="50">
                <mat-label>NIP</mat-label>
                <input matInput placeholder="NIP" [formControl]="sellerNipControl" [required]="sellerNipRequired"
                       mask="0000000000">
                <mat-error *ngIf="sellerNipControl.hasError('required')">To pole jest wymagane</mat-error>
                <mat-error *ngIf="sellerNipControl.hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
                <mat-error *ngIf="sellerNipControl.hasError('backendError')">{{ errors.nip }}</mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <mat-form-field fxFlex="50">
                <mat-label>Ulica</mat-label>
                <input appCapitalizeFirst matInput placeholder="Ulica" [formControl]="sellerStreetControl"
                       [required]="true">
                <mat-error *ngIf="sellerStreetControl.hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>

              <div fxFlex="50" fxLayout="row" fxLayoutGap="15px">
                <mat-form-field fxFlex="50">
                  <mat-label>Nr budynku</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Nr budynku" [formControl]="sellerHouseNumberControl"
                         [required]="true">
                  <mat-error *ngIf="sellerHouseNumberControl.hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="50">
                  <mat-label>Nr mieszkania</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Nr mieszkania"
                         [formControl]="sellerApartmentNumberControl" [required]="false">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <mat-form-field fxFlex="50">
                <mat-label>Poczta</mat-label>
                <input appCapitalizeFirst matInput placeholder="Poczta" [formControl]="sellerPostCityControl"
                       [required]="true">
                <mat-error *ngIf="sellerPostCityControl.hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="50">
                <mat-label>Kod pocztowy</mat-label>
                <input matInput placeholder="10-200" [formControl]="sellerZipCodeControl" [required]="true"
                       mask="99-999" [showMaskTyped]="true" [dropSpecialCharacters]="false">
                <mat-error *ngIf="sellerZipCodeControl.hasError('required')">To pole jest wymagane</mat-error>
                <mat-error *ngIf="sellerZipCodeControl.hasError('invalidZipCode')">Podaj prawidłowy kod pocztowy
                </mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <mat-form-field fxFlex="50">
                <mat-label>Miejscowość</mat-label>
                <input appCapitalizeFirst matInput placeholder="Miejscowość" [formControl]="sellerCityControl"
                       [required]="true">
                <mat-error *ngIf="sellerCityControl.hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="50">
                <mat-label>Numer rachunku bankowego</mat-label>
                <input
                  prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
                  matInput placeholder="PL27 1140 2004 0000 3002 0135 5387" [formControl]="sellerAccountNumberControl">
                <mat-error *ngIf="sellerAccountNumberControl.hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <mat-form-field fxFlex="50">
                <mat-label>Email</mat-label>
                <input appCapitalizeFirst matInput placeholder="Email" [formControl]="sellerEmailControl"
                       [required]="true">
                <mat-error *ngIf="sellerEmailControl.hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="50">
                <mat-label>Numer telefonu</mat-label>
                <input matInput placeholder="+48500600200 (bez spacji)" [formControl]="sellerPhoneControl"
                       [required]="true" prefix="+48" mask=" 000 000 000">
                <mat-error *ngIf="sellerPhoneControl.hasError('required')">To pole jest wymagane</mat-error>
                <mat-error *ngIf="sellerPhoneControl.hasError('invalidPhoneNumber')">Podaj prawidłowy numer telefonu
                </mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row">
              <mat-slide-toggle class="slide-padding" color="accent" [formControl]="vatInvoiceControl">Faktura VAT
              </mat-slide-toggle>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Metoda kasowa"
                               [value]="invoiceObject.checkoutMethod"></app-detail-bool>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Umowa"
                          [value]="invoiceObject?.contract?.type.name + ' (nr: ' + invoiceObject?.contract?.number + '), '
                          + invoiceObject?.contract?.status.name"
                          [link]="invoiceObject?.contract ? ['/umowy/szczegoly', invoiceObject?.contract.uuid] : undefined">
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="invoiceObject?.partner">
              <app-detail fxFlex="50" header="Strona umowy" value="Partner"></app-detail>

              <app-detail fxFlex="50" header="Partner" [value]="invoiceObject?.partner?.shortName"
                          [link]="invoiceObject?.partner ? ['/partnerzy/szczegoly', invoiceObject?.partner?.uuid] : undefined"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="invoiceObject?.ofwca">
              <app-detail fxFlex="50" header="Strona umowy" value="OFWCA"></app-detail>

              <app-detail fxFlex="100" header="OFWCA" [value]="invoiceObject?.ofwca?.fullName"
                          [link]="['/ofwca/szczegoly', invoiceObject?.ofwca?.uuid]"></app-detail>
            </div>

            <ng-container *ngIf="invoiceObject?.contract?.contractBalance">
              <div fxLayout="row" fxLayoutGap="15px">
                <app-detail fxFlex="100" header="Saldo">
                  {{ invoiceObject?.contract?.type.name + ' (nr: ' + invoiceObject?.contract?.number + '), ' + invoiceObject?.contract?.status.name }}
                </app-detail>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <app-detail fxFlex="25" header="Saldo początkowe"
                            [value]=""> {{ (invoiceObject?.contract?.contractBalance.initialBalanceNet === null ? 0 : invoiceObject?.contract?.contractBalance.initialBalanceNet) | number:'1.2-2' }}
                  zł
                </app-detail>
                <app-detail fxFlex="25" header="Do wypłacenia"
                            [value]="">{{ (invoiceObject?.contract?.contractBalance.toPayNet === null ? 0 : invoiceObject?.contract?.contractBalance.toPayNet) | number:'1.2-2' }}
                  zł
                </app-detail>
                <app-detail fxFlex="25" header="Wypłacono"
                            [value]="">{{ (invoiceObject?.contract?.contractBalance.paid === null ? 0 : invoiceObject?.contract?.contractBalance.paid) | number:'1.2-2' }}
                  zł
                </app-detail>
                <app-detail fxFlex="25" header="Ogólne"
                            [value]="">{{ (invoiceObject?.contract?.contractBalance.totalCommission === null ? 0 : invoiceObject?.contract?.contractBalance.totalCommission) | number:'1.2-2' }}
                  zł
                </app-detail>
              </div>
            </ng-container>

            <!--            <div fxLayout="row" *ngFor="let invoiceSettlement of invoiceObject.settlements">-->
            <!--              <app-detail fxFlex="100" header="Rozliczenie"-->
            <!--                          [link]="['/rozliczenia/szczegoly', invoiceSettlement?.contractSettlement.commissionSettlement.uuid]">-->
            <!--                {{invoiceSettlement?.contractSettlement.commissionSettlement?.billingMonth}}-->
            <!--                - {{invoiceSettlement.net | number:'1.2-2'}} zł / {{invoiceSettlement?.contractSettlement.totalCommission | number:'1.2-2'}} zł / pozostało: {{(invoiceSettlement?.contractSettlement.leftToPayContract === null ? 0 : invoiceSettlement?.contractSettlement.leftToPayContract) | number:'1.2-2'}} zł-->
            <!--              </app-detail>-->
            <!--            </div>-->

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane pliku</h3>
            </div>
            <div fxLayout="row">

              <app-file-drag-and-drop fxFlex="100"
                                      [multiple]="false"
                                      [generateOutput]="true"
                                      [maxSize]=fileMaxSize
                                      (fileSelected)="fileSelected($event)"
              ></app-file-drag-and-drop>

            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Nazwa</mat-label>
                <input matInput placeholder="Nazwa" [formControl]="fileNameControl" [required]="true">
                <mat-error *ngIf="fileNameControl.hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>
            </div>
            <div fxLayout="row">
              <h3>Plik aktualny</h3>
            </div>
            <div fxLayout="row">
              <button
                [disabled]="!(userPermissions | async).settlement.read"
                (click)="downloadPdf()"
                mat-stroked-button
              >
                <mat-icon>download</mat-icon>
                <span> {{ invoiceObject.fileName }}</span></button>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" *ngFor="let document of invoiceObject.documents">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>{{ document?.type.name }}</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Numer" [value]="document?.number"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail
                fxFlex="50" header="Kwota"
              >
                {{ (document.net === null ? 0 : document.net) | number:'1.2-2' }} zł
              </app-detail>

              <div fxFlex="50">
                <app-detail header="Data wystawienia" [value]="document.issueDate | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Powód" [value]="document.reason"></app-detail>
            </div>


          </mat-card>
        </div>
      </div>
    </div>

  </div>
</div>
